var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.55171C18 3.82909 13.9702 0 9 0C4.02981 0 0 3.82909 0 8.55171C0 12.8198 3.29068 16.3578 7.59387 17V11.0243H5.30811V8.55171H7.59387V6.66723C7.59387 4.52419 8.93798 3.33963 10.9934 3.33963C11.9781 3.33963 13.0083 3.50679 13.0083 3.50679V5.61135H11.873C10.7554 5.61135 10.4061 6.27037 10.4061 6.94744V8.55171H12.902L12.5033 11.0243H10.4061V17C14.7093 16.359 18 12.821 18 8.55171Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.df526145.svg";
export { ForwardRef as ReactComponent };